import { Box, styled } from '@mui/material';

/**
 * Centres the column's loading spinner over the sticky header, so it stays in
 * view however long the card list is.
 */
export const LoadingIndicatorOverlay = styled(Box)({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // Purely a loading indicator, so it adds no hit target of its own. What
  // actually blocks the header during the load is the column's `LoadingOverlay`,
  // which covers it.
  pointerEvents: 'none'
});
